<template>
  <v-menu
    v-if="items && items[0]"
    :class="{'ma-0 pa-0': !forFixed}"
    bottom
    offset-y
    :content-class="menuClass"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        dark
        icon
        :class="{'mx-1': offsetRight}"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <template v-for="(item, i) in items">
        <v-list-item
          v-if="item.title && !item.hide"
          :key="i"
          :to="item.to"
          :disabled="item.disabled"
          @click="itemClick($event, item)"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider
          v-else-if="!item.hide"
          :key="i"
        />
      </template>
      <slot />
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'PageContextMenu',

  props: {
    items: Array,
    offsetRight: Boolean,
    forFixed: Boolean,
    menuClass: [String, Object, Array]
  },

  data: function () {
    return {
    }
  },

  methods: {
    itemClick (event, item) {
      if (item.disabled) return
      item.action(event)
    }
  }
}
</script>
